export default __webpack_public_path__ + "static/media/Interior (8).98c9d878.jpg";